import type { ComponentType } from "react"
import type { Permission } from "@server/permissions"
import type { AdminRole } from "./session-context"
import {
  AbilityIcon,
  ChildrenIcon,
  ContentIcon,
  EventsIcon,
  FormsIcon,
  GivingIcon,
  MembersIcon,
  NominationsIcon,
  OverviewIcon,
  ProgramsIcon,
  SchoolsIcon,
  SponsorIcon,
} from "./components/icons"

export interface AdminNavItem {
  to: string
  end: boolean
  label: string
  icon: ComponentType<{ className?: string }>
  permission?: Permission
  superOnly?: boolean
}

export const NAV_ITEMS: readonly AdminNavItem[] = [
  { to: "/admin", end: true, label: "Overview", icon: OverviewIcon },
  { to: "/admin/children", end: false, label: "Children", icon: ChildrenIcon, permission: "children" },
  { to: "/admin/nominations", end: false, label: "Nominations", icon: NominationsIcon, permission: "nominations" },
  { to: "/admin/sponsors", end: false, label: "Sponsor", icon: SponsorIcon, permission: "sponsors" },
  { to: "/admin/giving", end: false, label: "Giving", icon: GivingIcon, permission: "giving" },
  { to: "/admin/schools", end: false, label: "Schools", icon: SchoolsIcon, permission: "schools" },
  { to: "/admin/programs", end: false, label: "Programs", icon: ProgramsIcon, permission: "programs" },
  { to: "/admin/ability", end: false, label: "Ability", icon: AbilityIcon, permission: "ability" },
  { to: "/admin/events", end: false, label: "Events", icon: EventsIcon, permission: "events" },
  { to: "/admin/forms", end: false, label: "Forms", icon: FormsIcon, permission: "forms" },
  { to: "/admin/content", end: false, label: "Content", icon: ContentIcon, permission: "content" },
]

export const TEAM_NAV_ITEMS: readonly AdminNavItem[] = [
  { to: "/admin/members", end: false, label: "Members", icon: MembersIcon, superOnly: true },
  { to: "/admin/roles", end: false, label: "Roles", icon: MembersIcon, superOnly: true },
]

export function canAccessNavItem(item: AdminNavItem, role?: AdminRole | null): boolean {
  if (!role) return false
  if (role.isSuper) return true
  if (item.superOnly) return false
  return !item.permission || role.permissions.includes(item.permission)
}

export function getAccessibleNavItems(
  items: readonly AdminNavItem[],
  role?: AdminRole | null,
): AdminNavItem[] {
  return items.filter((item) => canAccessNavItem(item, role))
}
